import React, { Fragment, useEffect,useState } from 'react';
import { Grid, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SnackBar } from 'src/components/SnackBar';
import { Helmet } from 'react-helmet-async';
import SegmentRows from './SegmentRows';
import {
  getRolePermissions
} from 'src/services/authService';
import { validateMultiRolesAndPermissions } from 'src/utils/validate';

const Segments = () => {

  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);

  const array = [];

  const getPermissions = (mail) => {
    getRolePermissions(mail).then((res) => {     
      const tabs = validateMultiRolesAndPermissions(res);

      const segments = tabs.filter((fil) => fil.name === 'Segments');
      segments[0].permissions.map((item) => {
        array.push(item);
      })

      const customer = tabs.filter((fil) => fil.name === 'Customer');
      customer[0].permissions.map((item) => {
        array.push(item);
      })

      const stakeholder = tabs.filter((fil) => fil.name === 'Stakeholder');
      stakeholder[0].permissions.map((item) => {
        array.push(item);
      })
      setPermissions(array);
    });
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (Object.keys(user).length === 0) {
      navigate('/');
    }
    getPermissions(user.Email);
  }, [navigate]);

  return (
    <Fragment>
      <Helmet>
        <title>Segments</title>
      </Helmet>
      <Container maxWidth="xl">
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="stretch"
          spacing={3}
        >
          <Grid item xs={12}>
            <SegmentRows permissions={permissions}/>
          </Grid>
        </Grid>
        <SnackBar />
      </Container>
    </Fragment>
  );
};

export default Segments;
